module.exports = __webpack_public_path__ + "img/btn-spotify.af26232b.png";